export const healthLabels = [
    {
        label: 'Vegan',
        value: 'vegan',
        description: 'No meat, poultry, fish, dairy, eggs or honey'
    },
    {
        label: 'Vegetarian',
        value: 'vegetarian',
        description: 'No meat, poultry, or fish'
    },
    {
        label: 'Sugar Conscious',
        value: 'sugar-conscious',
        description: 'Less than 4g of sugar per serving'
    },
    {
        label: 'Peanuts-free',
        value: 'peanut-free',
        description: 'No peanuts or products containing peanuts'
    },
    {
        label: 'Tree Nuts-free',
        value: 'tree-nut-free',
        description: 'No tree nuts or products containing tree nuts'
    },
    {
        label: 'Alcohol-free',
        value: 'alcohol-free',
        description: 'No alcohol used or contained'
    }
];
